import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND_URL}/api` });

let tokenGetter = null;
export const setTokenGetter = (fn) => { tokenGetter = fn; };

api.interceptors.request.use(async (config) => {
  if (tokenGetter) {
    const token = await tokenGetter();
    if (token) config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const fileSrc = (u) => (u ? `${BACKEND_URL}${u}` : null);
export const PLACEHOLDER_SRC = `${BACKEND_URL}/api/assets/property-placeholder.png`;
export const AGENCY_LOGO_SRC = `${BACKEND_URL}/api/assets/agency-logo-placeholder.png`;
export const onImgError = (e) => {
  const img = e.currentTarget;
  if (img.src === PLACEHOLDER_SRC) return;
  img.removeAttribute("srcset");
  img.src = PLACEHOLDER_SRC;
};

export const errMsg = (e, t) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return t(`errors.${d}`, d);
  if (Array.isArray(d)) return d[0]?.msg || t("errors.generic");
  return t("errors.generic");
};
